import { combineReducers } from '@reduxjs/toolkit';
import loadingReducer from '../features/loading/loadingSlice';
import entryReducer from '../features/entry/entrySlice';
import adminReducer from '../features/admin/adminSlice';

const createRootReducer = () => combineReducers({
    loading: loadingReducer,
    entry: entryReducer,
    admin: adminReducer,
});

export default createRootReducer;